import { render, staticRenderFns } from "./guessCard.vue?vue&type=template&id=c02a6fd2&scoped=true&"
import script from "./guessCard.vue?vue&type=script&lang=js&"
export * from "./guessCard.vue?vue&type=script&lang=js&"
import style0 from "./guessCard.vue?vue&type=style&index=0&id=c02a6fd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02a6fd2",
  null
  
)

export default component.exports